import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

import BPO from "../../components/Service/BPO";
import PageHeader from "../../components/ui/PageHeader";
import AnimatedPage from "../../components/ui/AnimatePage";
import Container from "../../components/ui/Container";
import { useIntroContext } from "../../hooks/useIntroContext";
import BlogList from "../../components/Blogs/BlogList";
import BlogDetail from "../../components/Blogs/BlogDetail";
import SuccessStoryDetail from "../../components/Stories/SucesfulStoriesDetail";





const SuccessStoryDetailPage: React.FC = () => {


  return (

          <Container>
            <SuccessStoryDetail />
        </Container>



  );
};

export default SuccessStoryDetailPage;

